import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLifeVest: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLifeVest"><Path d="M7 2V6C7 7.65685 5.65685 9 4 9H3V15H11V13H9V11H11V5.82929C9.83481 5.41746 9 4.30622 9 3V2H7Z" fill="currentColor"/><Path d="M13 5.82929V11H15V13H13V15H21V9H20C18.3431 9 17 7.65685 17 6V2H15V3C15 4.30622 14.1652 5.41746 13 5.82929Z" fill="currentColor"/><Path d="M21 17H13V21H21V17Z" fill="currentColor"/><Path d="M11 21V17H3V21H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLifeVest;
